import { initializeConnector } from "@web3-react/core";
import { WalletConnect } from "@web3-react/walletconnect";

export const connectWalletConnect = async (connector) => {
	await connector.activate(1);
};

export const [walletConnect, hooks] = initializeConnector(
	(actions) =>
		new WalletConnect(actions, {
			rpc: {1: "https://mainnet.infura.io/v3/cf7d42ffb1f643ebb6e738b7f45c0dc2"},
		}),
	[1]
);
